var _path, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2428 5.23756C15.2428 7.45855 17.0459 9.25902 19.2701 9.25902C19.5151 9.25782 19.7594 9.23431 20 9.18878V17.1615C20 20.5156 18.0215 22.5 14.6624 22.5H7.34636C3.97851 22.5 2 20.5156 2 17.1615V9.8561C2 6.50195 3.97851 4.5 7.34636 4.5H15.3131C15.2659 4.743 15.2423 4.99001 15.2428 5.23756ZM13.15 15.3966L16.0078 11.7088V11.6912C16.2525 11.3625 16.19 10.8989 15.8671 10.6463C15.7108 10.5257 15.5122 10.4735 15.3166 10.5016C15.1211 10.5297 14.9453 10.6358 14.8295 10.7956L12.4201 13.8951L9.67659 11.7351C9.51995 11.6131 9.32069 11.5592 9.1238 11.5857C8.9269 11.6121 8.74897 11.7166 8.63018 11.8756L5.67561 15.6863C5.57176 15.8158 5.51585 15.9771 5.51733 16.1429C5.50018 16.4781 5.71186 16.7826 6.03236 16.8838C6.35287 16.985 6.70136 16.8573 6.8803 16.5732L9.35123 13.3771L12.0948 15.5283C12.2508 15.6541 12.4514 15.7111 12.6504 15.6863C12.8494 15.6615 13.0297 15.5569 13.15 15.3966Z",
    fill: "#212121"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.2,
    cx: 19.5,
    cy: 5,
    rx: 2.5,
    ry: 2.5,
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuide);
export default __webpack_public_path__ + "static/media/guide.abc029138293e653cc918208db843adc.svg";
export { ForwardRef as ReactComponent };